//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { folderSpaceEntDeleteApi, folderSpaceEntListApi, folderSpaceEntRenameApi } from '@/api/cloud';
import file from '@/utils/file';
import { formatBytes } from '@/libs/public';
Vue.use(file);
import Vue from 'vue';
export default {
  name: 'SpaceFile',
  components: {
    imageViewer: function imageViewer() {
      return import('@/components/common/imageViewer');
    },
    moveDialog: function moveDialog() {
      return import('../moveDialog');
    },
    fileAttribute: function fileAttribute() {
      return import('../fileAttribute');
    },
    ElImageViewer: function ElImageViewer() {
      return import('element-ui/packages/image/src/image-viewer');
    },
    rightClick: function rightClick() {
      return import('../rightClick');
    },
    defaultPage: function defaultPage() {
      return import('@/components/common/defaultPage');
    },
    authorDialog: function authorDialog() {
      return import('../authorDialog');
    }
  },
  props: {
    fileStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    switch: {
      type: Number,
      default: 4
    },
    spaceId: {
      type: Number | String,
      default: 0
    },
    pageLimit: {
      type: Number,
      default: 0
    },
    wps_type: {
      type: String | Number,
      default: '0'
    },
    spaceType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      checked: false,
      fileData: [],
      activeValue: '',
      renameIndex: null,
      renameName: '',
      shareItem: {},
      where: {
        page: 1,
        limit: this.pageLimit,
        pid: '',
        is_del: 0
      },
      total: 0,
      breadcrumbArray: [],
      id: 0,
      isImage: false,
      srcList: [],
      formBoxConfig: {},
      menuIds: [],
      handleData: {
        id: 0,
        ids: []
      },
      moveData: {
        id: 0,
        type: 3
      },
      rightData: {
        type: 6,
        data: {}
      },
      rightClickIndex: -1,
      fromData: {},
      pageHeight: 0,
      prevHeight: 0
    };
  },
  mounted: function mounted() {},
  computed: {
    lang: function lang() {
      return this.$store.getters.lang;
    }
  },
  watch: {
    pageLimit: function pageLimit(val) {
      this.where.limit = val;
    }
  },
  methods: {
    setOptions: function setOptions() {
      this.breadcrumbArray[0].name = this.$t('file.allfiles');
    },
    pageChange: function pageChange(page) {
      this.where.page = page;
      this.getTreeData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.getTreeData();
    },
    //获取数据
    getTreeData: function getTreeData(val) {
      var _this = this;
      if (val == 1) {
        this.where.page = val;
      }
      var data = {
        page: this.where.page,
        limit: this.pageLimit,
        pid: this.where.pid,
        file_type: this.fileTypeName(this.fileStyle.type),
        keyword: this.fileStyle.keyword,
        is_del: this.where.is_del
      };
      data.sort_by = this.fileSortName(this.fileStyle.sortBy);
      data.sort_type = this.fileSortName(this.fileStyle.sort);
      folderSpaceEntListApi(this.spaceId, data).then(function (res) {
        _this.fileData = res.data.list;
        _this.total = res.data.count;
        _this.$emit('totalFn', _this.total);
      });
      // }
    },
    // 查看与下载附件
    lookViewer: function lookViewer(item) {
      var _this2 = this;
      this.isImage = true;
      var url = item.file_url;
      if (this.fileData.length > 0) {
        this.fileData.map(function (value, index) {
          if (value === url) {
            _this2.fileData.splice(index, 1);
          }
        });
        this.srcList.unshift(url);
      }
      this.$refs.imageViewer.openImageViewer(url);
    },
    formatBytesFn: function formatBytesFn(size) {
      if (size) {
        size = Number(size);
        return formatBytes(size);
      } else {
        return '--';
      }
    },
    // 分享云文件
    shareOther: function shareOther(item) {
      this.$emit('shareItemFile', item);
    },
    // 点击item项
    getItemFile: function getItemFile(item) {
      if (item.type == 1) {
        this.where.pid = item.id;
        this.where.is_shortcut = 0;
        if (this.breadcrumbArray.findIndex(function (n) {
          return n.pid == item.id;
        }) < 0) {
          this.breadcrumbArray.push({
            name: item.name,
            pid: item.id
          });
          this.getTreeData(1);
          this.handlerEmit({
            name: item.name,
            pid: item.id
          });
        }
      } else {
        this.$emit('openItemFile', item);
      }
    },
    closeImageViewer: function closeImageViewer() {
      this.isImage = false;
    },
    // 点击面包屑
    getBreadcrumb: function getBreadcrumb(id, index) {
      if (id != this.where.pid) {
        if (this.switch === 5 && id == '') {
          this.where.is_shortcut = 1;
        }
        this.where.page = 1;
        this.where.pid = id;
        this.getTreeData();
      }
    },
    handlerEmit: function handlerEmit(item) {
      this.handleData.id = this.where.pid === '' ? 0 : this.where.pid;
      this.handleData.ids = this.menuIds;
      this.$emit('handlerMyFile', this.handleData, item);
    },
    handleShow: function handleShow(index) {
      this.activeValue = index;
    },
    checkChange: function checkChange(type) {
      var _this3 = this;
      if (type === 1) {
        if (this.fileData && this.fileData.length > 0) {
          this.fileData.map(function (item) {
            if (_this3.menuIds.findIndex(function (n) {
              return n === item.id;
            }) < 0) {
              _this3.checked = true;
              _this3.menuIds.push(item.id);
            } else {
              _this3.checked = false;
              if (_this3.menuIds.findIndex(function (n) {
                return n == item.id;
              }) > -1) {
                _this3.menuIds.splice(_this3.menuIds.findIndex(function (n) {
                  return n == item.id;
                }), 1);
              }
            }
          });
        }
      } else {
        if (this.menuIds.length === 1 && this.menuIds[0] === 0) {
          this.checked = false;
          this.menuIds = [];
        }
      }
      this.handlerEmit();
    },
    itemCheckChange: function itemCheckChange(row) {
      if (this.fileStyle.style === 1) return false;
      if (this.menuIds.includes(row.id)) {
        this.menuIds.splice(this.menuIds.findIndex(function (n) {
          return n === row.id;
        }), 1);
      } else {
        this.menuIds.push(row.id);
      }
      this.handlerEmit();
    },
    addAuthor: function addAuthor(row) {
      this.fromData = {
        title: this.$t('file.setdirectory'),
        fid: this.spaceId,
        id: row.id,
        edit: 1
      };
      this.$refs.authorDialog.handleOpen();
    },
    getStartCollect: function getStartCollect(item) {
      this.getCollect(item);
      this.closePopover();
    },
    // 删除
    getFolderDelete: function getFolderDelete(id) {
      var _this4 = this;
      this.$modalSure('你确定要删除该内容吗').then(function () {
        folderSpaceEntDeleteApi(_this4.spaceId, id).then(function (res) {
          if (_this4.where.page > 1 && _this4.fileData.length <= 1) {
            _this4.where.page--;
          }
          _this4.getTreeData();
          _this4.closePopover();
        });
      });
    },
    // 重命名
    setRenameItem: function setRenameItem(item, index) {
      this.renameIndex = index;
      this.renameName = item.name;
      this.closePopover();
      this.$nextTick(function () {
        document.getElementById('input' + index).focus();
      });
    },
    // 失去焦点
    renameBlur: function renameBlur(item) {
      this.renameIndex = null;
      if (item.name === '') {
        item.name = this.renameName;
        return false;
      }
      if (this.renameName !== this.trim(item.name)) {
        this.getFolderRename(item, {
          name: item.name
        });
      }
    },
    // 重命名
    getFolderRename: function getFolderRename(item, data) {
      var _this5 = this;
      var id = this.spaceType == 'recently' ? item.pid : this.spaceId;
      folderSpaceEntRenameApi(id, item.id, data).then(function (res) {
        _this5.getTreeData();
      }).catch(function (error) {
        _this5.getTreeData();
      });
    },
    getFileAttribute: function getFileAttribute(item) {
      this.formBoxConfig = {
        title: this.$t('file.fileattribute'),
        is_file: false,
        fid: this.spaceType == 'recently' ? item.pid : this.spaceId,
        id: item.id,
        width: '450px'
      };
      this.$refs.fileAttribute.openBox();
    },
    // 移动或复制
    getMoveDialog: function getMoveDialog(item, type) {
      if (type === 1) {
        this.moveData.type = 3;
      } else {
        this.moveData.type = 6;
      }
      this.moveData.id = item.id;
      this.moveData.fid = item.pid || this.spaceId;
      this.$refs.moveDialog.handleOpen();
    },
    // 移动回调
    handlerMove: function handlerMove(data) {
      if (data.type === 3 || data.type === 6) {
        this.getTreeData();
      }
    },
    closePopover: function closePopover() {
      if (this.rightClickIndex > -1) {
        this.rightClickIndex = -1;
      } else {
        this.$refs["pop-".concat(this.activeValue)][0].doClose();
      }
    },
    rightClick: function rightClick(event, item, index) {
      this.rightData.data = item;
      this.rightClickIndex = index;
      this.$refs.rightClick.menuVisible = true;
      this.$refs.rightClick.rightClick(event);
    },
    // 右键
    handleRightClick: function handleRightClick(data) {
      if (data.index === 1) {
        // 预览
        this.getItemFile(data.row);
      }
      if (data.index === 2) {
        // 移动
        this.getMoveDialog(data.row, 1);
      } else if (data.index === 3) {
        // 复制
        this.getMoveDialog(data.row, 2);
      } else if (data.index === 4) {
        // 重命名
        this.setRenameItem(data.row, this.rightClickIndex);
      } else if (data.index === 5) {
        // 属性
        this.getFileAttribute(data.row);
      } else if (data.index === 6) {
        // 删除
        this.getFolderDelete(data.row.id);
      } else if (data.index === 9) {
        // 设置权限
        this.addAuthor(data.row);
      } else if (data.index == 10) {
        // 分享
        this.shareOther(data.row);
      }
    }
  }
};